import slick from "slick-carousel";
window.jQuery = $;

console.log('holaaaa')

const openModal = (id, slickConfig) => {
    let modal = $('#' + id);

    modal.addClass('active');

    //Desactivamos scroll del body
    if (modal.hasClass('active')) {
        $('body').css({ overflow: 'hidden' });
    }
    
    modal.fadeIn(400, () => {
        modal.find('#close-modal').on('click', () => {
            modal.fadeOut(400);
            $('body').removeAttr("style");
        });
    });

}

const applySlick = (id, config) => {
    if ($("#" + id).hasClass('slick-initialized')) {
        $(this).slick('unslick');
    }

    $("#" + id).slick(config);
}

$(document).ready(function () {
    //Detalle de producto
    $('.collection-products-container').on('click', 'button#open-product-details', e => {
        let $this = $(e.currentTarget);
        $('#modal-product-details .modal-body').load($this.data('href'), () => {
            openModal('modal-product-details');
            setTimeout(() => {
                let config = {
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 1,
                    arrows: true,
                    fade: true,
                    cssEase: 'linear',
                    prevArrow: $('#prev-arrow-product'),
                    nextArrow: $('#next-arrow-product'),
                }
                applySlick("gallery-modal-product-detail", config)
            }, 10);
            setTimeout(() => {
                $("#gallery-modal-product-detail").slick('refresh')
            }, 400);
        });
    }); 

    //Formulario para asistir a evento
    $('#open-form-assist').on('click', () => {
        openModal('modal-form-assist');
    });

    //Modelo - Especificaciones tecnicas
    $('#open-model-specs').on('click', () => {
        openModal('modal-model-specs');
    });
    $('#open-model-specs-mobile').on('click', () => {
        openModal('modal-model-specs');
    });

    //Modelo - Accesorios
    $('#open-model-accessories').on('click', () => {
        openModal('modal-model-accessories');
    });
    $('#open-model-accessories-mobile').on('click', () => {
        openModal('modal-model-accessories');
    });

    //Detalle de piloto de carreras
    $('.cards-driver-container').on('click', '.card-driver', e => {
        let $this = $(e.currentTarget);
        openModal($this.data('modal-id'));
    })

    //Motorsport - Especificaciones tecnicas
    $('#open-model-specs-motorsport').on('click', () => {
        openModal('modal-model-specs-motorsport');
    });

});